"use strict";

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.function.name.js");

var _escape = _interopRequireDefault(require("lodash/escape"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _ = {
  escape: _escape.default
};

var _default = function _default(obj) {
  var __t,
      __p = '',
      __e = _.escape,
      __j = Array.prototype.join;

  function print() {
    __p += __j.call(arguments, '');
  }

  __p += '\n<li class="zotero-item zotero-' + __e(obj.data.itemType) + '" data-item="' + __e(obj.item.key) + '" id="item-' + __e(obj.item.key) + '" role="listitem">\n	<a href="#" class="zotero-line" aria-hidden="true" role="presentation" tabindex="-1"></a>\n\n	<!-- Citation -->\n	';

  if (obj.renderer.config.useCitationStyle) {
    ;
    __p += '\n		' + ((__t = obj.renderer.renderItemCitation(obj.item)) == null ? '' : __t) + '\n	<!-- Templated -->\n	';
  } else {
    ;
    __p += '\n		' + ((__t = obj.renderer.renderItemTemplated(obj.item)) == null ? '' : __t) + '\n	';
  }

  ;
  __p += '\n\n	<div class="zotero-item-actions">\n		<a href="#' + __e(obj.item.key) + '" data-trigger="details" aria-controls="item-' + __e(obj.item.key) + '-details">\n			Details\n		</a>\n		';

  if (obj.renderer.zotero.config.zorgIntegration) {
    ;
    __p += '\n			<a href="" data-trigger="add-to-library" aria-controls="item-' + __e(obj.item.key) + '-details">\n				Add to Library\n			</a>\n		';
  }

  ;
  __p += '\n	</div>\n\n	<!-- Details -->\n	<section class="zotero-details zotero-collapsable" aria-expanded="false" id="item-' + __e(obj.item.key) + '-details">\n		<div class="zotero-details-inner">\n			<table class="zotero-meta">\n				';

  if (obj.item.data['itemType']) {
    ;
    __p += '\n					<tr class="zotero-meta-item">\n						<td class="zotero-meta-label">' + __e(obj.renderer.fieldMap['itemType']) + '</td>\n						<td class="zotero-meta-value">' + __e(obj.renderer.typeMap[obj.item.data['itemType']]) + '</td>\n					</tr>\n				';
  }

  ;
  __p += '\n\n				';

  if (obj.item.data[obj.constants.AUTHORS_SYMBOL]) {
    ;
    __p += '\n					';

    for (var i = 0, keys = Object.keys(obj.item.data[obj.constants.AUTHORS_SYMBOL]); i < keys.length; i++) {
      ;
      __p += '\n						<tr class="zotero-meta-item">\n							<td class="zotero-meta-label">' + __e(keys[i]) + '</td>\n							<td class="zotero-meta-value zotero-creators">\n								';

      for (var j = 0; j < Math.min(obj.renderer.zotero.config.authorsListed, obj.item.data[obj.constants.AUTHORS_SYMBOL][keys[i]].length); j++) {
        ;
        __p += '\n									<span class="zotero-creator">\n										' + __e(obj.item.data[obj.constants.AUTHORS_SYMBOL][keys[i]][j]) + '\n									</span>\n								';
      }

      ;
      __p += '\n								';

      if (obj.item.data[obj.constants.AUTHORS_SYMBOL][keys[i]].length > obj.renderer.zotero.config.authorsListed) {
        ;
        __p += '\n									<a href="" class="zotero-creator" data-trigger="expand-authors">\n										More...\n									</a>\n								';
      }

      ;
      __p += '\n								';

      for (var j = obj.renderer.zotero.config.authorsListed; j < obj.item.data[obj.constants.AUTHORS_SYMBOL][keys[i]].length; j++) {
        ;
        __p += '\n									<span class="zotero-creator zotero-creator-hidden">\n										' + __e(obj.item.data[obj.constants.AUTHORS_SYMBOL][keys[i]][j]) + '\n									</span>\n								';
      }

      ;
      __p += '\n							</td>\n						</tr>\n					';
    }

    ;
    __p += '\n				';
  }

  ;
  __p += '\n				';

  for (var i = 0, keys = Object.keys(obj.data); i < keys.length; i++) {
    ;
    __p += '\n					';

    if (obj.renderer.hiddenFields.indexOf(keys[i]) === -1) {
      ;
      __p += '\n						';

      if (obj.data[keys[i]]) {
        ;
        __p += '\n							';

        if (keys[i] !== 'itemType') {
          ;
          __p += '\n								<tr class="zotero-meta-item">\n									<td class="zotero-meta-label">' + __e(obj.renderer.fieldMap[keys[i]]) + '</td>\n									<td class="zotero-meta-value">\n										';

          if (keys[i] === 'DOI') {
            ;
            __p += '\n											<a href="https://doi.org/' + __e(encodeURIComponent(obj.data[keys[i]])) + '" rel="nofollow">\n												' + __e(obj.data[keys[i]]) + '\n											</a>\n										';
          } else if (keys[i] === 'url') {
            ;
            __p += '\n											<a href="' + __e(obj.utils.sanitizeURL(obj.data[keys[i]])) + '" rel="nofollow">\n												' + __e(obj.data[keys[i]]) + '\n											</a>\n										';
          } else {
            ;
            __p += '\n											' + __e(obj.data[keys[i]]) + '\n										';
          }

          ;
          __p += '\n									</td>\n								</tr>\n							';
        }

        ;
        __p += '\n						';
      }

      ;
      __p += '\n					';
    }

    ;
    __p += '\n				';
  }

  ;
  __p += '\n			</table>\n			';

  if (obj.data.abstractNote && obj.data.abstractNote.length) {
    ;
    __p += '\n				<h4>Abstract</h4>\n				<div class="zotero-abstract">\n					' + ((__t = obj.data[obj.constants.ABSTRACT_NOTE_PROCESSED]) == null ? '' : __t) + '\n				</div>\n			';
  }

  ;
  __p += '\n\n			';

  if (obj.item[obj.constants.CHILD_NOTES] && obj.item[obj.constants.CHILD_NOTES].length) {
    ;
    __p += '\n				<h4>Notes</h4>\n				<ul class="zotero-notes">\n					';

    var _iterator = _createForOfIteratorHelper(obj.item[obj.constants.CHILD_NOTES]),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var childItem = _step.value;
        ;
        __p += '\n						<li>\n							' + ((__t = childItem.data.note) == null ? '' : __t) + '\n						</li>\n					';
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    ;
    __p += '\n				</ul>\n			';
  }

  ;
  __p += '\n\n			';

  if (obj.item[obj.constants.CHILD_ATTACHMENTS] && obj.item[obj.constants.CHILD_ATTACHMENTS].length) {
    ;
    __p += '\n				<h4>Attachments</h4>\n				<ul class="zotero-attachments">\n					';

    var _iterator2 = _createForOfIteratorHelper(obj.item[obj.constants.CHILD_ATTACHMENTS]),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var childItem = _step2.value;
        ;
        __p += '\n						<li>\n							';

        if (childItem.url || childItem.links && childItem.links.enclosure && childItem.links.enclosure.href) {
          ;
          __p += '\n							<a href="' + __e(obj.utils.sanitizeURL(childItem.url)) + '" rel="nofollow">\n							';
        }

        ;
        __p += '\n								<span class="zotero-icon zotero-icon-paperclip" role="presentation" aria-hidden="true"></span><!--\n								-->' + __e(childItem.title) + '\n							';

        if (childItem.url || childItem.links && childItem.links.enclosure && childItem.links.enclosure.href) {
          ;
          __p += '\n							</a>\n							';
        }

        ;
        __p += '\n						</li>\n\n					';
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    ;
    __p += '\n				</ul>\n			';
  }

  ;
  __p += '\n			';

  if (obj.renderer.zotero.userId) {
    ;
    __p += '\n				<!-- Cite & export -->\n				<div class="zotero-toolbar">\n					<ul class="zotero-list-inline" role="tablist">\n						<li class="zotero-tab" >\n							<a href="" data-trigger="cite" role="tab" aria-selected="false" aria-controls="item-' + __e(obj.item.key) + '-cite">Cite</a>\n						</li>\n						<li class="zotero-tab">\n							<a href="" data-trigger="export" role="tab" aria-selected="false" aria-controls="item-' + __e(obj.item.key) + '-export">Export</a>\n						</li>\n					</ul>\n				</div>\n\n				<div class="zotero-tab-content">\n					<!-- Cite -->\n					<div role="tabpanel" class="zotero-cite-container zotero-tabpanel" aria-expanded="false" id="item-' + __e(obj.item.key) + '-cite">\n						<div class="zotero-container-inner">\n							<select class="zotero-form-control" data-trigger="cite-style-selection">\n								';

    for (var citationStyle in obj.renderer.zotero.config.citeStyleOptions) {
      ;
      __p += '\n									<option value="' + ((__t = citationStyle) == null ? '' : __t) + '" ';

      if (citationStyle === obj.renderer.config.citeStyleOptionDefault) {
        ;
        __p += ' selected ';
      }

      ;
      __p += '>\n										' + ((__t = obj.renderer.zotero.config.citeStyleOptions[citationStyle]) == null ? '' : __t) + '\n									</option>\n								';
    }

    ;
    __p += '\n							</select>\n							<p class="zotero-citation" id="item-' + __e(obj.item.key) + '-citation"></p>\n							';

    if (typeof navigator !== 'undefined' && !/iPhone|iPad/i.test(navigator.userAgent)) {
      ;
      __p += '\n								<button class="zotero-btn zotero-citation-copy tooltipped tooltipped-e" data-clipboard-target="#item-' + __e(obj.item.key) + '-citation" aria-label="Copy to clipboard">Copy</button>\n							';
    }

    ;
    __p += '\n						</div>\n					</div>\n\n					<!-- Export -->\n					<div role="tabpanel" class="zotero-export-container zotero-tabpanel" aria-expanded="false" aria-hidden="true" id="item-' + __e(obj.item.key) + '-export">\n						<div class="zotero-container-inner">\n							<select class="zotero-form-control" data-trigger="export-format-selection">\n								';

    for (var exportFormat in obj.renderer.zotero.config.exportFormats) {
      ;
      __p += '\n									<option value="' + ((__t = exportFormat) == null ? '' : __t) + '">\n										' + ((__t = obj.renderer.zotero.config.exportFormats[exportFormat].name) == null ? '' : __t) + '\n									</option>\n								';
    }

    ;
    __p += '\n							</select>\n							<p class="zotero-export"></p>\n						</div>\n					</div>\n				</div>\n			';
  }

  ;
  __p += '\n		</div>\n	</section>\n</li>';
  return __p;
};

exports.default = _default;